export const ConsumerEmailErrorStyles = {
  banner: 'text-red100 flex justify-center py-4',
}
